<template>
  <div class="main-tracker">
    <div class="dashboard-widget-tabs">
      <img v-if="isSX" src="/static/images/icons/sb_due_date.svg" class="submission-icons" />
      <img v-else src="/static/images/icons/sb_due_date.svg" class="submission-icons" />
      <span>Due Dates</span>
    </div>
    <div
      class="dashboard-widget-bodies"
      :class="{ 'fix-height': isCombo, 'single-height': !isCombo }"
    >
      <div
        class="dashboard-widget-body"
        data-tab="tracker"
        data-widget="2"
        v-for="(items, index) in data"
        :key="index"
      >
        <h3>{{ index | capitalize }}</h3>
        <div v-if="items.length == 0 && index == 'today'">
          <div class="empty-data">There are no nodes due today.</div>
        </div>
        <div v-if="items.length == 0 && index == 'soon'">
          <div class="empty-data">There are no nodes due within the next 60 days.</div>
        </div>
        <div class="row dashboard-widget-due-date" v-for="item in items" :key="item.id">
          <div class="col-xs-11 display-inline" :class="{ 'pl-36': isCombo, 'pl-35': !isCombo }">
            <div class="widget-icon">
              <img src="/static/images/icons/calender_icon.svg" class="calender-icon" />
            </div>
            <a class="cursor-pointer" @click="redirect(item.nextUrl)"
              >{{ item.title }} is due {{ item.due }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['sbData', 'isCombo', 'isSX'],
  data() {
    return {
      data: {}
    };
  },
  created() {
    this.accessData();
  },
  methods: {
    async accessData() {
      const x = this.sbData;
      this.data = x.dueDates;
      if (this.data.today.length > 1) {
        this.data.today.splice(1);
      }
      if (this.data.soon.length > 1) {
        this.data.soon.splice(1);
      }
    },
    redirect(url) {
      if (this.isSX) {
        this.$router.push(`/layout/smart-exchange?nextUrl=${url}`);
      } else {
        this.$router.push(`/layout/submission-builder?nextUrl=${url}`);
      }
    }
  },
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style scoped>
.pl-36 {
  padding-left: 36px;
}
.submission-icons {
  width: 32px;
  height: 32px;
  margin-top: -3px;
}
.dashboard-widget-tabs {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0b3c61;
  padding-left: 22px;
  padding-top: 24px;
}
.dashboard-widget-tabs span {
  padding-left: 16px;
}
.empty-data {
  padding-left: 22px;
}
.widget-card {
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.fix-height {
  max-height: 220px;
}
.single-height {
  max-height: 182px;
}
.dashboard-widget-bodies {
  overflow-y: auto;
  scrollbar-width: thin;
  overflow-x: hidden;
}
.dashboard-widget-body h3 {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
  padding-left: 22px;
}
.dashboard-widget-body .dashboard-widget-due-date {
  display: flex;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 5px;
}
.dashboard-widget-due-date a,
.dashboard-widget-due-date .empty-data {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 17px;
  padding-right: 5px;
}
.due-date {
  margin-top: 25px;
}
.dashboard-widget .dashboard-widget-tabs {
  height: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.7);
}
.pl-5 {
  padding-left: 5px;
}
.status-expiry {
  margin-bottom: 22px;
  margin-left: -8px;
}
.status-project-node {
  padding-left: 10px;
}
.project-node {
  padding-left: 30px;
}
.widget-icon {
  margin-top: -2px;
}
.widget-icon img {
  width: 24px;
  height: 24px;
}
.pl-35 {
  padding-left: 35px;
}
.display-inline {
  display: inline-flex;
}
</style>
